import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-evaluation-selection',
  templateUrl: './evaluation-selection.component.html',
  styleUrls: ['./evaluation-selection.component.scss']
})
export class EvaluationSelectionComponent {
  constructor(private router: Router
  ) { }

  evaluateTrain() {
    this.router.navigate(['/evaluation/train']);
  }

  evaluateVariant() {
    this.router.navigate(['/evaluation/variant']);
  }
}
